export default "__VITE_ASSET__3de4a620__"